export default __webpack_public_path__ + "static/media/premiumIcon.62416d82.svg";